import classes from "./TabsulQuiz.module.css";
import logo from "../Assets/green.png";
import finish from "../Assets/finish.png";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { asyncLoad, setSelection } from "../Store/StaffReducer/staffSlice";
import Loading from "../Components/Loading";
import Error from "../Components/Error";

const TabsulQuiz = () => {

  const { id } = useParams();
  const { qs } = useParams();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const data = useSelector((state) => state.staff.data);
  const loading = useSelector((state) => state.staff.loading);
  const error = useSelector((state) => state.staff.error);

  const totalQuestions = Number(qs);

  const timeMap = {
    100: 120 * 60,
    50: 60 * 60,
    20: 20 * 60,
  };

  const TOTAL_TIME = timeMap[totalQuestions] || 60 * 60;

  const [timeLeft, setTimeLeft] = useState(TOTAL_TIME);

  const [currentQuestion, setCurrentQuestion] = useState(0);

  const [result, setResult] = useState(0);
  const [score, setScore] = useState(0);
  const [attempted, setAttempted] = useState(0);
  const [timeTaken, setTimeTaken] = useState(0);

  const handleNextQuestion = () => {
    if (currentQuestion < data.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    } else {
      setCurrentQuestion(0);
    }
  }

  const handlePrevQuestion = () => {
    if (currentQuestion > 0) {
      setCurrentQuestion(currentQuestion - 1);
    } else {
      setCurrentQuestion(data.length - 1);
    }
  }

  const goback = () => {
    navigate("/"); // redirect to home
  };

  useEffect(() => {
    dispatch(asyncLoad({ id, qs }));
  }, [id, qs, dispatch]);

  const handleAnswer = (option) => {
    dispatch(setSelection({ qsnumber: currentQuestion, option }));
  }

  const selectedCounter = () => {
    let count = 0;
    let datacounter = 0;
    data.forEach((qs) => {
      datacounter++;
      if (qs.selected) {
        count++;
      }
    });
    if (count === datacounter) {
      return true
    } else {
      return false
    }
  }

  const handleTimeUp = () => {
    let correctCount = 0;
    let attemptedCount = 0;

    data.forEach((q) => {
      if (q.selected && q.selected !== "") {
        attemptedCount++;

        if (q.selected === q.Correct) {
          correctCount++;
        }
      }
    });

    setScore(correctCount);
    setAttempted(attemptedCount);
    setTimeTaken(TOTAL_TIME - timeLeft); // ⏱️ time used

    setResult(1); // show result screen
  };

  useEffect(() => {
    if (result === 1) return; // stop timer if quiz is over
    if (timeLeft <= 0) {
      handleTimeUp(); // 🔥 event when timer hits 0
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft, result]);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;

    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
  };

  if (loading) {
    return <div style={{ marginTop: '15rem' }}> <Loading /> </div>

  }

  if (error) {
    return <Error message="Failed to load quiz data. Please try again." />;
  }


  return (
    result === 0 ? <div className={classes.page}>

      <section className={classes.hero}>
        <img src={logo} alt="Tabsul Logo" className={classes.heroLogo} />
      </section>

      <div className={classes.center}>
        <div className={classes.timerhead}>
          <div className={classes.timer}>
            <p>{formatTime(timeLeft)}</p>
          </div>
          <div className={classes.qsnumber}>
            <p>{currentQuestion + 1}</p>
          </div>
        </div>
      </div>

      {/* QUESTIONS */}
      <div className={classes.QsSection}>
        <div className={classes.question}>
          <p>{data[currentQuestion].question}</p>
        </div>

        <div className={classes.options}>
          {['A', 'B', 'C', 'D'].map((option) => (
            <div
              key={option}
              className={`${classes.optionButton} ${data[currentQuestion].selected === option ? classes.selected : ''
                }`}
              onClick={() => handleAnswer(option)}
            >
              <p>{data[currentQuestion][option]}</p>
            </div>
          ))}
        </div>
      </div>

      {/* NAVIGATION BUTTONS */}
      <div className={classes.navButtons}>
        <button className={classes.prevButton} onClick={handlePrevQuestion}>
          Previous
        </button>
        {selectedCounter() && (
          <button onClick={handleTimeUp} className={classes.submitButton}>
            Submit
          </button>
        )}
        <button className={classes.nextButton} onClick={handleNextQuestion}>
          Next
        </button>
      </div>
    </div>


      :

      <div className={classes.page}>
        <section className={classes.hero}>
          <img src={logo} alt="Tabsul Logo" className={classes.heroLogo} />
        </section>

        <div className={classes.resultContainer}>

          <h2 className={classes.resultTitle}>Exam Finished</h2>

          <div className={classes.scoreCircle}>
            <h1>
              {Number.isInteger((score / qs) * 100)
                ? (score / qs) * 100
                : ((score / qs) * 100).toFixed(1)} %
            </h1>
          </div>


          <img src={finish} alt="Finished" className={classes.resultImage} />



          {/* 🔥 BIG SCORE */}

          <div className={classes.resultBox}>
            <div className={classes.resultItem}>
              <p>Attempted</p>
              <span>{attempted}</span>
            </div>

            <div className={classes.resultItem}>
              <p>Total Questions</p>
              <span>{data.length}</span>
            </div>

            <div className={classes.resultItem}>
              <p>Time Taken</p>
              <span>
                {Math.floor(timeTaken / 60)}:
                {(timeTaken % 60).toString().padStart(2, "0")}
              </span>
            </div>


          </div>
          <button className={classes.nextButton} style={{ marginBottom: '20px' }} onClick={goback}>
            Home
          </button>
        </div>
      </div>
  );
};

export default TabsulQuiz;